/** Stable first-fit cells shared by tidy and time-page capacity calculations. */
export interface PackingFrame {
  id: string;
  w: number;
  h: number;
  fullRow?: boolean;
}
export interface PackingPlacement extends PackingFrame {
  x: number;
  y: number;
}
const CELL = 440;
const GAP = 40;
interface Cell {
  x: number;
  y: number;
  occupied: boolean[];
}
function slots(frame: PackingFrame): number[][] | null {
  if (frame.w === 180 && frame.h === 130) return [[0], [1], [2], [3]];
  if (frame.w === 400 && frame.h === 130)
    return [
      [0, 1],
      [2, 3],
    ];
  if (frame.w === 400 && frame.h === 300) return [[0, 1, 2, 3]];
  return null;
}
export function packFrameGrid(
  frames: readonly PackingFrame[],
  columns: number,
  xOrigin = 0,
): PackingPlacement[] {
  const cells: Cell[] = [];
  const placements: PackingPlacement[] = [];
  let column = 0;
  let rowTop = 0;
  let rowHeight = 0;
  const flush = () => {
    if (!column) return;
    rowTop += rowHeight + GAP;
    column = 0;
    rowHeight = 0;
  };
  for (const frame of frames) {
    const choices = frame.fullRow ? null : slots(frame);
    let cell = choices
      ? cells.find((candidate) =>
          choices.some((choice) => choice.every((i) => !candidate.occupied[i])),
        )
      : undefined;
    if (frame.fullRow) {
      flush();
      cells.length = 0; // Later controls remain below the full-row frame.
    }
    if (!cell) {
      const span = frame.fullRow
        ? columns
        : Math.min(columns, Math.max(1, Math.ceil((frame.w + GAP) / CELL)));
      if (column + span > columns) flush();
      const x = xOrigin + column * CELL;
      if (choices) {
        cell = { x, y: rowTop, occupied: [false, false, false, false] };
        cells.push(cell);
      } else placements.push({ ...frame, x, y: rowTop });
      column += span;
      rowHeight = Math.max(rowHeight, choices ? 300 : frame.h);
      if (column >= columns) flush();
    }
    if (choices && cell) {
      const choice = choices.find((candidate) =>
        candidate.every((i) => !cell.occupied[i]),
      )!;
      choice.forEach((i) => {
        cell.occupied[i] = true;
      });
      const first = choice[0]!;
      placements.push({
        ...frame,
        x: cell.x + (first % 2) * 220,
        y: cell.y + Math.floor(first / 2) * 170,
      });
    }
  }
  return placements;
}
